<ion-row class="sc-color-light-light-mode-bg">
  <ion-col class="ion-no-padding">
    <ion-row class="ion-align-items-center ion-text-center" id="left-container">
      <ion-col
        offset-xs="1"
        size-xs="10"
        offset-sm="1"
        size-sm="10"
        offset-md="1"
        size-md="10"
        offset-lg="2"
        size-lg="8"
        offset-xl="3"
        size-xl="6">
        <div id="permissions">
          <h3 class="ion-text-center regular">
            For others to see and hear you, SquadCast needs access to your microphone and camera.
          </h3>

          <h3 class="ion-text-center animate__animated" [class.animate__headShake]="headShake">
            <strong>Allow</strong> browser permissions above.
          </h3>

          <ion-button
            aria-label="Get Started"
            class="primary"
            (click)="getStarted()"
            shape="round"
            fill="solid"
            size="medium">
            Get Started
          </ion-button>

          <p class="ion-text-center micro-regular">
            <a (click)="openSupportCenter()" href="javascript:void(0)" alt="Support Center"> Need help? </a>
          </p>
        </div>
      </ion-col>
    </ion-row>
    <div id="pro-tip-footer" class="sc-color-white-100-bg">
      <ion-button
        aria-label="SupportArticles[proTip.topic].description"
        (click)="learnMore(proTip.topic)"
        shape="round"
        id="pro-tip-button"
        tooltip="Click to visit our help center for more information."
        class="warning">
        <ion-label class="regular">
          <ion-icon slot="start" src="assets/icons/24px/{{ proTip.icon }}.svg"></ion-icon>
          Pro Tip
        </ion-label>
      </ion-button>

      <ion-row>
        <ion-col>
          <ion-item lines="none">
            <ion-label class="ion-text-wrap ion-text-center">
              <h3 class="regular">
                <strong>
                  {{ proTip.title }}
                </strong>
              </h3>
              <br />
              <p class="pro-tip-desc">
                {{ proTip.description }}
                <sc-learn-more [topic]="proTip.topic" class="inline"></sc-learn-more>
              </p>
            </ion-label>
          </ion-item>
        </ion-col>
      </ion-row>
    </div>
  </ion-col>

  <ion-col size-xs="0" size-sm="0" class="ion-no-padding" size-md="5" size-lg="4" size-xl="4" id="right-container">
    <img
      [src]="
        (theme$ | async) === 'dark-theme'
          ? 'assets/images/SC_D_Logo_Horizontal-LM.svg'
          : '/assets/images/SC_D_Logo_Horizontal-DM.svg'
      "
      alt="SquadCast Logo"
      id="logo" />

    <ion-row class="ion-align-items-center" id="quote-container">
      <ion-col>
        <blockquote class="ion-align-items-center" [class.fadeout]="fadeOut" *ngIf="quotes && quotes.length > 0">
          <!-- <blockquote class="ion-align-items-center" [class.fadeout]="fadeOut" *ngIf="quotes && quotes.length > 0"> -->
          <h4 class="regular">"{{ quotes[currentQuote].quote }}"</h4>
          <br />
          <cite>
            <p class="regular">
              <strong>{{ quotes[currentQuote].name }}</strong>
              <br />
              {{ quotes[currentQuote].podcast }}
            </p>
          </cite>

          <img src="{{ quotes[currentQuote].image }}" alt="Profile image for {{ quotes[currentQuote].name }}" />
        </blockquote>
      </ion-col>
    </ion-row>

    <div class="spacer"></div>
  </ion-col>
</ion-row>
